import moment from "moment-timezone";
import jstz from "jstimezonedetect";
export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = array => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

export const checkPermisssion = (mainMenu, subMenu) => {
  let permissionList = localStorage.getItem("permission");
  permissionList = JSON.parse(permissionList);
  let selectedModule = _.find(permissionList, item => item.module == mainMenu);
  if (selectedModule) {
    if (subMenu) {
      let findSubMenu = _.find(
        selectedModule.submenu,
        item => item.module == subMenu
      );
      if (findSubMenu) {
        return findSubMenu.write;
      } else {
        return false;
      }
    }
    return selectedModule.write;
  }
  return false;
};
export const checkPermisssionRole = (mainMenu, subMenu, action) => {
  let permissionList = localStorage.getItem("permission");
  permissionList = JSON.parse(permissionList);
  let selectedModule = _.find(permissionList, item => item.module == mainMenu);
  if (selectedModule) {
    if (subMenu) {
      let findSubMenu = _.find(
        selectedModule.submenu,
        item => item.module == subMenu
      );
      if (findSubMenu) {
        if (action == 'hide') {
          return !findSubMenu[action];
        }
        return findSubMenu[action];
      } else {
        return false;
      }
    }
    if (action == 'hide') {
      return !selectedModule[action];
    }
    return selectedModule[action];
  }
  return false;
};
export const isNumberValidatorphone = evt => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
    evt.preventDefault();
  } else {
    return true;
  }
};
export const validateNegativeNumber = evt => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
    evt.preventDefault();
  } else {
    return true;
  }
};
export const isNumberValidator = evt => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
  } else {
    return true;
  }
};
export const preventSpecialChar = event => {
  if (event.keyCode == 33 || event.keyCode == 35 || event.keyCode == 39 || event.keyCode == 126 || event.keyCode == 96 || event.keyCode == 124 || event.keyCode == 36 || event.keyCode == 95 || event.keyCode == 37 || event.keyCode == 94 || event.keyCode == 42 || event.keyCode == 40 || event.keyCode == 41 || event.keyCode == 38 || event.keyCode == 125 || event.keyCode == 123 || event.keyCode == 63 || event.keyCode == 43 || event.keyCode == 61 || event.keyCode == 47) {
    event.preventDefault();
  }
};
export const TimeConversion = (date, formatReq) => {
  var format = "YYYY-MM-DD HH:mm";
  // If format param not passed assign default date format 
  if (formatReq != null) {
    format = formatReq
  }
  let checkTime = moment(date).format("HH:mm");
  // IF time is 00:00 need to convert into utc time other wise normal time. If we are not convert UTC it will give 05:30 time
  if (checkTime == "00:00") {
    return moment
      .tz(date, format)
      .tz(jstz.determine().name()).utc()
      .format(format);
  } else {
    return moment
      .tz(date, format)
      .tz(jstz.determine().name())
      .format(format);
  }

};

export const CONSTANTS = {
  default: 100,
  phone: 10,
  MaxPhone: 13,
  postalCode: 8,
  fax: 10,
  imageSizeMax: 512,
  title: 60,
  body: 255
};

export const pickAs = (obj, props) => {
  let temp = {};
  let data = Object.entries(props).reduce((r, [k, v]) => {
    if (k in props) temp[k] = _.get(obj, v, '');
    return temp;
  }, {});
  return data;
};

export const phoneDigitValidation = evt => {
  let phoneLength = evt.replace(/[^0-9 ]/g, "").length;
  if (phoneLength >= 10 && phoneLength <= 11) {
    return false;
  }
  return true;

}